import { render } from "./AssetsForm.vue?vue&type=template&id=8389bc1e"
import script from "./AssetsForm.vue?vue&type=script&lang=js"
export * from "./AssetsForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__